import { GlassPanel } from '../ui/GlassPanel';
import { Check, Info } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { useState } from 'react';

interface AddOnModuleCardProps {
  name: string;
  description: string;
  price: number;
  priceRange?: { min: number; max: number };
  features: string[];
  icon: LucideIcon;
  category: string;
  isSelected: boolean;
  onToggle: () => void;
}

export function AddOnModuleCard({
  name,
  description,
  price,
  priceRange,
  features,
  icon: Icon,
  category,
  isSelected,
  onToggle,
}: AddOnModuleCardProps) {
  const [showDetails, setShowDetails] = useState(false);

  const displayPrice = priceRange
    ? `€${priceRange.min}-€${priceRange.max}`
    : `€${price}`;

  return (
    <GlassPanel
      className={`p-6 transition-all cursor-pointer ${
        isSelected
          ? 'border-2 border-primary-400 bg-primary-500/10'
          : 'hover:border-white/30'
      }`}
      onClick={onToggle}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={onToggle}
              onClick={(e) => e.stopPropagation()}
              className="w-5 h-5 rounded border-2 border-white/30 bg-transparent checked:bg-primary-500 checked:border-primary-400 cursor-pointer"
            />
          </div>
          <Icon className="w-8 h-8 text-primary-400" />
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setShowDetails(!showDetails);
          }}
          className="text-white/60 hover:text-white transition-colors"
        >
          <Info className="w-5 h-5" />
        </button>
      </div>

      <div className="mb-3">
        <h4 className="text-lg font-bold text-white mb-1">{name}</h4>
        <span className="text-xs px-2 py-1 rounded-full bg-white/10 text-white/60">
          {category}
        </span>
      </div>

      <p className="text-sm text-white/70 mb-4">{description}</p>

      <div className="flex items-baseline gap-2 mb-4">
        <span className="text-3xl font-bold text-primary-300">{displayPrice}</span>
        <span className="text-white/60 text-sm">/month</span>
      </div>

      {showDetails && (
        <div className="mt-4 pt-4 border-t border-white/10 space-y-2">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-2 text-xs text-white/70">
              <Check className="w-4 h-4 text-success-400 flex-shrink-0 mt-0.5" />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      )}
    </GlassPanel>
  );
}
